import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Typography,
	Grid
} from '@material-ui/core';

import Constants from "../utils/Constants";

const styles = makeStyles(theme => ({
	up: {
		color: theme.palette.secondary.orange
	},

	constant: {
		color: theme.palette.grey[500]
	},

	down: {
		color: theme.palette.primary.main
	},

	chevron: {
		fontSize: "1rem",
		marginLeft: theme.spacing(1)
	},

	inactive: {
		textTransform: "capitalize",
		color: theme.palette.grey[500]
	}
}));

const changeInfo = {
	"up": {
		icon: "chevron-circle-up",
		title: "increasing momentum"
	},
	"constant": {
		icon: "minus-circle",
		title: "no momentum"
	},
	"down": {
		icon: "chevron-circle-down",
		title: "decreasing momentum"
	}
};

function PatternMomentum(props) {
	let classes = styles(),
		{status, momentum} = props,
		changeColor = classes[momentum];

	return status === Constants.PATTERN.STATUSES.ACTIVE ? (
		<Grid container
			wrap="nowrap"
			alignItems="center">
			<Grid item>
				<Typography className={changeColor}>Momentum</Typography>
			</Grid>
			<Grid item>
				<FontAwesomeIcon
					icon={["fas", changeInfo[momentum].icon]}
					className={`${changeColor} ${classes.chevron}`}
					title={changeInfo[momentum].title} />
			</Grid>
		</Grid>
	) : <Typography className={classes.inactive}>{Constants.PATTERN.STATUSES.INACTIVE}</Typography>;
}

PatternMomentum.defaultProps = {
	momentum: "constant"
};

PatternMomentum.propTypes = {
	status: PropTypes.string,
	momentum: PropTypes.string
};

export default PatternMomentum;